import { CurrencyPipe } from "@angular/common";
import { AbstractControl } from "@angular/forms";

function getNumericFromValue(val: any): number | null {
  if (val === null || val === undefined || val === '') return null;
  const cleaned = val.toString().replace(/[^0-9.-]/g, '');
  const num = parseFloat(cleaned);
  return isNaN(num) ? null : num;
}

export function formatCurrencyInput(
  control: AbstractControl | null,
  inputElement: HTMLInputElement | null,
  currencyPipe: CurrencyPipe,
  currencyCode: string = 'USD',
  display: 'symbol' | 'code' | 'symbol-narrow' = 'symbol',
  digitsInfo: string = '1.0-2'
): void {
  if (!control) return;

  // prefer the DOM value (user-typed) if present
  const domValue = inputElement?.value;
  const raw =
    domValue !== undefined && domValue !== null && domValue !== '' ? domValue : control.value;

  const numeric = getNumericFromValue(raw);
  if (numeric === null) {
    control.setValue('', { emitEvent: false });
    if (inputElement) inputElement.value = '';
    return;
  }

  // keep numeric in the FormControl
  control.setValue(numeric, { emitEvent: false });

  // but write the formatted string to the input
  const formatted = currencyPipe.transform(numeric, currencyCode, display, digitsInfo) ?? '';
  if (inputElement) {
    inputElement.value = formatted;
  }
}

export function validateNumberInput(event: KeyboardEvent) {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
  if (allowedKeys.includes(event.key)) {
    return;
  }

  // Only digits or dot
  if (!/^[0-9.]$/.test(event.key)) {
    event.preventDefault();
    return;
  }

  const input = (event.target as HTMLInputElement).value;

  // Prevent multiple dots
  if (event.key === '.' && input.includes('.')) {
    event.preventDefault();
    return;
  }

  // Prevent more than 2 digits after dot
  const parts = input.split('.');
  if (parts.length === 2 && parts[1].length >= 2) {
    event.preventDefault();
  }
}

export function validatePasteInput(event: ClipboardEvent) {
  const pasted = event.clipboardData?.getData('text') ?? '';
  if (!/^\d*(\.\d{0,2})?$/.test(pasted)) {
    event.preventDefault();
  }
}
